<template>
	<div class="dff__question" :ref="questionref">
		<div class="dff__intro-dff">
			<img src="/ResourcePackages/BaldwinHardware/assets/dist/images/logos/lock-designer-pp.svg" alt="puzzle pieces" width="40" height="40" >
			<span>Door Fit Finder</span>
		</div>
		<h2 class="dff__question-heading">{{ question }}</h2>
		<template v-if="answers?.length">
			<ul class="dff__answer-list">
				<li v-for="answer in answers" class="dff__answer-item">
					<div class="dff__answer-card" @click="setAnswer(answer)">
						<div class="dff__answer-card-image-wrap" v-if="answer?.answerImage">
							<img class="dff__answer-card-image" :src="answer?.answerImage" :alt="answer?.answer">
						</div>
						<div class="dff__answer-card-title">{{answer?.answer}}</div>
					</div>
				</li>
			</ul>
		</template>
		<template v-if="isFirstQuestion === false">
			<Button @click="goBack()" class="dff__back btn btn-outline-primary btn-lg">Back</Button>
		</template>
	</div>
</template>

<script setup>
import {ref, onMounted, onBeforeUnmount} from 'vue';
import { useStore } from 'vuex';
const store = useStore();
import jsonData from 'Data/doorfitfinder.json';
const { questionobject, question, answers, questionref } = defineProps(['questionobject', 'question', 'answers', 'questionref']);
const isFirstQuestion = ref(false);



const setAnswer = (answer) => {
	store.commit('setAnsweredQuestionData', answer?.answerValue);
	store.commit('updatePreviousQuestion', question?.id);
	store.commit('updateActiveQuestion', answer?.nextQuestion);

	if(answer.nextQuestion === 'loading') {
		store.commit('updateActiveComponent', answer?.nextQuestion);
	}
};

const checkIfIsFirstQuestion = async(id) => {
	// Find the item with the specified ID
	const questionItem = await jsonData.questions?.find(item => item?.id === questionobject?.id);

	// Check if the item is at index 0
	isFirstQuestion.value = questionItem?.id === `Q1`;
}

onMounted(() => {
	checkIfIsFirstQuestion(question?.id);
	if (questionref.value) {
		setTimeout(() => {
			questionref.value.classList.add('state-mounted')
		}, 500);
	}
});

onBeforeUnmount(() => {
	if (questionref.value) {
		questionref.value.classList.remove('state-mounted');
		setTimeout(() => {
			//giving the css animation time to finish before mounting the next thing
		}, 500);
	}
});

const goBack = () => {
	store.commit('updateActiveQuestion', 'Q1');
	store.commit('removeSetDFFStates');
};
</script>
